/// <amd-module name="Artifacts/Npm/redux/Actions" />

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  IDefaultActionPayload,
  IDeleteActionPayload,
  IPromoteActionPayload,
  IRestoreActionPayload,
  IUpstreamOverrideActionPayload,
} from "Artifacts/Root/Protocols/types/ICommandActionPayloads";
import { trackActionWithCount } from "Artifacts/Root/redux/Actions";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

export const enum NpmActionTypes {
  Deprecate = "Artifacts/Npm/Deprecate",
  Promote = "Artifacts/Npm/Promote",
  PermanentDelete = "Artifacts/Npm/PermanentDelete",
  Restore = "Artifacts/Npm/Restore",
  Download = "Artifacts/Npm/Download",
  SoftDelete = "Artifacts/Npm/SoftDelete",
  SetUpstreamOverride = "Artifacts/Npm/SetUpstreamOverride",
}

export interface IDeprecateActionPayload {
  feed: IFeed;
  versions: IPackageVersionIdentity[];
  deprecateMessage: string;
  onSuccessCallback: (versions: IPackageVersionIdentity[], deprecateMessage: string) => void;
}

export const NpmActions = {
  deprecate: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    deprecateMessage: string,
    onSuccessCallback: (versions: IPackageVersionIdentity[], deprecateMessage: string) => void,
  ) =>
    trackActionWithCount(
      createAction<NpmActionTypes, IDeprecateActionPayload>(NpmActionTypes.Deprecate, {
        feed,
        versions,
        deprecateMessage,
        onSuccessCallback,
      }),
      versions.length,
    ),
  softDelete: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<NpmActionTypes, IDeleteActionPayload>(NpmActionTypes.SoftDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  promote: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    viewId: string,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<NpmActionTypes, IPromoteActionPayload>(NpmActionTypes.Promote, {
        feed,
        versions,
        viewId,
        onSuccessCallback,
      }),
      versions.length,
    ),
  permanentDelete: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<NpmActionTypes, IDeleteActionPayload>(NpmActionTypes.PermanentDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  restore: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<NpmActionTypes, IRestoreActionPayload>(NpmActionTypes.Restore, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  download: (feed: IFeed, versions: IPackageVersionIdentity[]) =>
    trackActionWithCount(
      createAction<NpmActionTypes, IDefaultActionPayload>(NpmActionTypes.Download, {
        feed,
        versions,
      }),
      versions.length,
    ),
  setUpstreamOverride: (
    feed: IFeed,
    packageName: string,
    allowExternalVersions: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackedAction(
      createAction<NpmActionTypes, IUpstreamOverrideActionPayload>(
        NpmActionTypes.SetUpstreamOverride,
        { feed, packageName, allowExternalVersions, onSuccessCallback },
      ),
    ),
};

export type NpmProtocolActionsUnion = ActionsUnion<typeof NpmActions>;
